<template>
	<div class="MAM_stockList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="stockForm" class="demo-form-inline">

				<el-form-item>
					<el-input size clearable v-model="stockForm.terminal_sn" placeholder="请输入SN"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="stockForm.real_name" placeholder="请输入所属代理商名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="stockForm.agent_no" placeholder="请输入代理编号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-select size clearable v-model="stockForm.brand_id" placeholder="请选择政策名称" style="width:180px;">
						<el-option :label="item.name" :value="item.id" v-for="(item,index) in optionList"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select size="medium" v-model="stockForm.terminal_type" filterable clearable style="width:100%"
						placeholder="请选择终端类型">
						<el-option label="银盛POS" value="1"></el-option>
						<el-option label="手机POS" value="2"></el-option>
						<el-option label="杉德POS" value="3"></el-option>
						<el-option label="联动POS" value="4"></el-option>
                        <el-option label="海科POS" value="5"></el-option>
                        <el-option label="银盛尊享POS" value="6"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-date-picker size clearable v-model="rangeDate" type="datetimerange" range-separator="至"
						start-placeholder="申请开始日期" end-placeholder="申请结束日期" value-format="yyyy-MM-dd"
						@change="pickerChange"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-date-picker size clearable v-model="rangeDate2" type="datetimerange" range-separator="至"
						start-placeholder="审核开始日期" end-placeholder="审核结束日期" value-format="yyyy-MM-dd"
						@change="pickerChange2"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(stockForm)">查询</el-button>
					<el-button style="font-size: 12px;margin-left:20px" size="small" type="primary" icon="el-icon-download"
						:loading="downLoading" @click="handleDownLoad(stockForm)">导出数据</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<el-table :data="stockTable.list" size="mini" border style="width: 100%" v-loading="loading">
				<el-table-column header-align="center" align="center" fixed type="index" label="ID"
					min-width="80"></el-table-column>
				<el-table-column header-align="center" align="center" prop="sn" label="SN"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="term_type" label="终端型号"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="terminal_type_text" label="终端类型"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="brand_name" label="政策名称"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="agent_no" label="所属代理商编号"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="real_name" label="所属代理商名称"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="bind_time" label="绑定时间"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="active_time" label="激活时间"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="create_time" label="入库时间"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="status" label="兑换状态"
					min-width="80">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 0"
							style="color: #67C23A;">未兑换</span>
						<span v-if="scope.row.status == 1"
							style="color: #F56C6C;">已兑换</span>
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="apply_time" label="申请时间"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="audit_time" label="审核时间"
					min-width="120"></el-table-column>

			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize"></paginations>
		</el-card>

	</div>
</template>

<script>
	import paginations from '../../../components/pagination/paginations';
	export default {
		name: "exchangeDetails",
		data() {
			return {
				level: sessionStorage.getItem('level'),
				rangeDate: '',
				rangeDate2: '',
				optionList: [],
				stockForm: {
					terminal_sn: '',
					merchant_number: '',
					phone: '',
					agent_no: '',
					real_name:'',
					terminal_type:'',
					apply_time_start: '',
					apply_time_end: '',
					audit_time_start:'',
					audit_time_end:'',
					brand_id: '',
				},
				stockTable: {
					list: [],
				},
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 100 //总数
				},
				loading: true,
                dataItem:{}
			}
		},
		mounted() {
			this.brandList();
			//初始化
			this.getData({
				page: this.page.currentPage,
				limit: this.page.pageSize
			})
		},
		components: {
			paginations,
		},
		methods: {
			//导出
			handleDownLoad(params) { 
                params.is_admin = this.dataItem.is_admin
                params.admin_id = this.dataItem.admin_id
                params.level = this.dataItem.level
				console.log(params);
				let reqData = {
					type: 18,
					value: JSON.stringify(params),
				};
				console.log(reqData);
				this.downLoading = true;
				this.$api.post('export/add', reqData, res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.downLoading = false;
					} else {
						this.$message.error(res.msg);
						this.downLoading = false;
					}
			
				})
			},
			//获取2.0政策
			brandList() {
				this.$api.post("userlevel/selBrandList", {}, res => {
					this.optionList = res.data;
				})
			},
			pickerChange(DateArr) { //时间选择器
				this.stockForm.apply_time_start = this._.isEmpty(DateArr) ? '' : DateArr[0];
				this.stockForm.apply_time_end = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},
			pickerChange2(DateArr) { //时间选择器
				this.stockForm.audit_time_start = this._.isEmpty(DateArr) ? '' : DateArr[0];
				this.stockForm.audit_time_end = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},
			onSearch(stockForm) {
				this.page.currentPage = 1;
				stockForm.page = this.page.currentPage;
				stockForm.limit = this.page.pageSize;
				// 表单提交
				this.getData(stockForm);
			},

			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.loading = true;
				this.page.currentPage = page;
				this.stockForm.page = page;
				this.stockForm.limit = this.page.pageSize;
				this.getData(this.stockForm)
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.loading = true;
				this.page.pageSize = limit;
				this.stockForm.page = this.page.currentPage;
				this.stockForm.limit = limit;
				this.getData(this.stockForm);
			},
			getData(params) {
				this.$api.post("terminal_exchange/getAllExchangeRecordList", params, res => {
					let data = res.data;
					this.page.total = data.count; //总数
					this.stockTable.list = data.list;
                    this.dataItem = data
					//渲染结束后取消加载
					this.loading = false;
				});
			}
		},

	};
</script>

<style lang="scss" scope>
	.MAM_stockList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}
	}
</style>